import styles from './index.module.sass';
import { EqualSign, ArrowMulti } from '../../images';
import bunkerSvg from '../../images/bunker.svg';
import classNames from 'classnames';

export const FilledMixingStep = ({ multi, bunkers, weightArray, totalPrice, profit }: IMixingStep) => {
  return (
    <div className={classNames(styles.stepBody, styles.stepFilledBody)}>
      <div className={styles.warehouse}>
        <span className={styles.warehouse__data}>
          <strong className={styles.strong}>
            {multi === true ? (
              'отсек 1 (75%)'
            ) : (
              <>
                {bunkers[0]} <img src={bunkerSvg} alt="icon" />
              </>
            )}
          </strong>
        </span>
        <span className={styles.warehouse__weight}>
          <strong>{weightArray[0]}</strong>т
        </span>
      </div>
      <div className={styles.separatorImage}>
        <img src={ArrowMulti} alt="icon" />
      </div>
      <div className={styles.warehouse}>
        <span className={styles.warehouse__data}>
          <strong className={styles.strong}>
            {multi === true ? (
              'отсек 2 (25%)'
            ) : (
              <>
                {bunkers[1]} <img src={bunkerSvg} alt="icon" />
              </>
            )}
          </strong>
        </span>
        <span className={styles.warehouse__weight}>
          <strong>{weightArray[1]}</strong>т
        </span>
      </div>
      <div className={styles.separatorImage}>
        <img src={EqualSign} alt="icon" />
      </div>
      <div className={styles.warehouse__result}>
        {totalPrice && <span className={styles.warehouse__data}>
          <strong>{multi === true ? 'Итог' : 'Итог'}</strong>
          {Number(totalPrice).toLocaleString('RU-ru', { maximumFractionDigits: 0 }) + ' ₽'}
        </span>}
        { profit && profit > 0 && <span className={styles.warehouse__profit}>
            выгода <strong style={{color: "#007E3C"}}>{'+ ' + profit.toLocaleString('RU-ru', { maximumFractionDigits: 0 })+ ' ₽'}</strong>
        </span>}
        <span className={styles.warehouse__weight}>
          {weightArray[2]} т
        </span>
      </div>
    </div>
  );
};

interface IMixingStep {
  multi: boolean;
  bunkers: any;
  weightArray: [number, number, number];
  totalPrice?: number;
  profit?: number;
}
